import type { ReservationStatus } from '@shared/types/reservations';

export const mapReservationStatus = (status: ReservationStatus): string => {
  if (status === 'autoResolved') return 'finished';
  return status;
};

export const isReservationFinished = (status: ReservationStatus): boolean =>
  ['autoResolved', 'finished'].includes(status);
